import type { SceneContext } from '../global/SceneContext'

// scene life cycle
// 默认相机创建前
// 默认相机创建
// 初次渲染前
export const SceneLifeCycle = {

}

// outside load use
export const SceneEventName = {
  LoadingStart: 'loading-start',
  LoadingProgress: 'loading-progress',
  LoadingEnd: 'loading-end',
  LoadingError: 'loading-error',
}

/**
 * registerEvents
 */
export const registerEvents = (context: SceneContext) => {
  Object.values(SceneEventName).forEach((key) => {
    context.emitter.on(key, (data) => {
      if (context.eventCallbacks.has(key)) {
        context.eventCallbacks.get(key)!.forEach((callback) => {
          callback(data)
        })
      }
    })
  })
}

/**
 * removeCurrentEvent
 * @param eventName
 */
export const removeCurrentEvent = (eventName: string, context?: SceneContext) => {
  context?.emitter.off(eventName)
}